import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { LocationStep } from './Location';

async function loadLocationStep(): Promise<typeof LocationStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-location" */ './Location')).LocationStep;
}

export function LocationLoader(): JSX.Element {
	return (
		<LazyComponent
			loadComponent={loadLocationStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadLocationStep = loadLocationStep;
